<template>
    <TemplateNews page="news" />
</template>
